/**
 * 全局Web Components配置文件
 *
 * 用于集中管理所有需要按需加载的Web Components
 * 当需要添加新组件时，只需在此文件中添加配置
 */

// 定义所有组件的配置
const COMPONENTS_CONFIG = [
  // 轮播组件
  {
    tag: "carousel-slider",
    path: "./carousel-slider.js",
    observeChildren: true,
  },

  // 懒加载组件
  {
    tag: "lazy-image",
    path: "./lazy-image.js",
    observeChildren: true,
  },

  // 这里可以添加更多组件...
  // 例如:
  // {
  //   tag: 'product-card',
  //   path: './product-card.js',
  //   observeChildren: true
  // },
  // {
  //   tag: 'custom-tabs',
  //   path: './tabs-component.js',
  //   observeChildren: true
  // }
];

// 导出配置，使其可以被其他模块导入
export default COMPONENTS_CONFIG;

// 可以导出额外的工具函数
export function findComponentConfig(tagName) {
  return COMPONENTS_CONFIG.find((config) => config.tag === tagName);
}

// 导出添加新组件的辅助函数
export function addComponentConfig(newConfig) {
  // 检查是否已存在同名组件
  const existingIndex = COMPONENTS_CONFIG.findIndex(
    (config) => config.tag === newConfig.tag
  );

  if (existingIndex >= 0) {
    // 更新现有配置
    COMPONENTS_CONFIG[existingIndex] = newConfig;
  } else {
    // 添加新配置
    COMPONENTS_CONFIG.push(newConfig);
  }

  return COMPONENTS_CONFIG;
}
